import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This ensures smooth scrolling
    });
  };
  return (
    <footer className="bg-blue-900 text-white py-1 mt-10">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-6 mt-10" >
        {/* Column 1 */}
        <div>
          <h2 className="text-4xl font-bold mb-12 ">ApplicationUni</h2>
          <p className="text-sm leading-relaxed">
            DSM 439, 4th Floor,<br />
            DLF Towers, Shivaji Marg,<br />
            Moti Nagar, New <br />
             Delhi,110015, India

          </p>
          <br />
          <p className="text-sm leading-relaxed">
          2007, Marina Pear Business Center, <br />
          Trade Center, Sheikh Zayed Road, Dubai,<br />
          United Arab Emirates

          </p>
          <p className="text-sm leading-relaxed mt-8 font-semibold">
            info@applicationuni.com <br />
            www.applicationuni.com
          </p>
          
        </div>

        {/* Column 2 */}
        <div>
        <h3 className="text-lg font-bold mb-3 ">Our Trips</h3>
          
          <ul>
          <li>
        <Link to="/tours/london-tour" className="hover:underline" onClick={scrollToTop}>
          London Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/australia-tour" className="hover:underline" onClick={scrollToTop}>
          Australia Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/dubai-tour" className="hover:underline" onClick={scrollToTop}>
          Dubai Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/usa-tour" className="hover:underline" onClick={scrollToTop}>
          US NASA Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/united-nations-tour" className="hover:underline" onClick={scrollToTop}>
          UN Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/singapore-tour" className="hover:underline" onClick={scrollToTop}>
          Singapore Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/japan-tour" className="hover:underline" onClick={scrollToTop}>
          Japan Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/south-korea-tour" className="hover:underline" onClick={scrollToTop}>
          South Korea Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/spain-tour" className="hover:underline" onClick={scrollToTop}>
          Spain Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/silicon-valley-tour" className="hover:underline" onClick={scrollToTop}>
          Silicon Valley Trip
        </Link>
      </li>
          </ul>
          
        </div>

        {/* Column 3 */}
        <div>
          <h3 className="text-lg font-bold mb-3">About</h3>
          <ul>
            <li>
              <Link to="/aboutus" className="hover:underline" onClick={scrollToTop}>
                Our Story
              </Link>
            </li>
            <li>
              <Link to="/aboutus" className="hover:underline" onClick={scrollToTop}>
                Our Vision
              </Link>
            </li>
            <li>
              <Link to="/aboutus" className="hover:underline" onClick={scrollToTop}>
                Our Journey
              </Link>
            </li>
          </ul>
          <h3 className="text-lg font-bold mt-6 mb-3">Contact Us</h3>
          <ul>
            <li>
              <Link to="/contact" className="hover:underline" onClick={scrollToTop}>
                Contact Form
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:underline" onClick={scrollToTop}>
                Our Location
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div>
          <h3 className="text-lg font-bold mb-3">Destinations</h3>
          <ul>
            <li>
              <Link to="/destination" className="hover:underline" onClick={scrollToTop}>
                Summer Schools
              </Link>
            </li>
            <li>
              <Link to="/destination" className="hover:underline" onClick={scrollToTop}>
                Past Tours
              </Link>
            </li>
            <li>
              <Link to="/destination" className="hover:underline" onClick={scrollToTop}>
                Testimonials
              </Link>
            </li>
            <li>
              <Link to="/destination" className="hover:underline" onClick={scrollToTop}>
                Impacts
              </Link>
            </li>
          </ul>
          <h3 className="text-lg font-bold mt-6 mb-3">Programs</h3>
          <ul>
            <li>
              <Link to="/programs" className="hover:underline" onClick={scrollToTop}>
                Partner Universities
              </Link>
            </li>
            <li>
              <Link to="/programs" className="hover:underline" onClick={scrollToTop}>
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/eligibility" className="hover:underline" onClick={scrollToTop}>
                AI Eligibility Checker
              </Link>
            </li>
            <li>
              <Link to="/ai-certification" className="hover:underline" onClick={scrollToTop}>
                AI Online Course
              </Link>
            </li>
            <li>
              <Link to="/corporate-travel" className="hover:underline" onClick={scrollToTop}>
                Corporate Travel
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {/* Copyright */}
      <div className="text-right mt-0 text-sm mr-10">
        © 2024-2025 ApplicationUni Inc.
      </div>
    </footer>
  );
};

export default Footer;
